import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import { AuthProvider } from './state/auth'
import './styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('SellGPT could not start: #root is missing from index.html.')

createRoot(container).render(
  <StrictMode>
    {/* BrowserRouter, not HashRouter: sellgpt.in/quotes is a real, shareable URL. IIS serves index.html
        for it (public/web.config), and the router takes it from there. */}
    {/* Outermost, so a crash anywhere below becomes a message the customer can act on rather than a page
        whose buttons have silently stopped responding. */}
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
)
